import { API_CONFIG } from '../config/api';

export interface ProcedureStep {
  id: number;
  step_order: number;
  title: string;
  description: string;
  image_url: string | null;
  category: string;
  is_active: number;
  created_at: string;
  updated_at: string;
}

const BASE_URL = `${API_CONFIG.BASE_URL}/procedure-steps`;

export const procedureStepService = {
  async getAll(params?: { category?: string; active?: boolean }): Promise<ProcedureStep[]> {
    const query = new URLSearchParams();
    if (params?.category) query.set('category', params.category);
    if (params?.active) query.set('active', 'true');
    const url = query.toString() ? `${BASE_URL}?${query.toString()}` : BASE_URL;
    const res = await fetch(url, { credentials: 'include' });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  async getById(id: number): Promise<ProcedureStep> {
    const res = await fetch(`${BASE_URL}/${id}`, { credentials: 'include' });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  async create(step: { step_order?: number; title: string; description?: string; category?: string }): Promise<ProcedureStep> {
    const res = await fetch(BASE_URL, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(step),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  async update(id: number, step: Partial<ProcedureStep>): Promise<ProcedureStep> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(step),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  async delete(id: number): Promise<void> {
    const res = await fetch(`${BASE_URL}/${id}`, { method: 'DELETE', credentials: 'include' });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
  },

  async reorder(items: { id: number; step_order: number }[]): Promise<ProcedureStep[]> {
    const res = await fetch(`${BASE_URL}/reorder`, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  async uploadImage(id: number | null, file: File): Promise<{ image_url: string }> {
    const formData = new FormData();
    formData.append('image', file);
    const url = id ? `${BASE_URL}/${id}/upload-image` : `${BASE_URL}/upload-image`;
    const res = await fetch(url, { method: 'POST', credentials: 'include', body: formData });
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  async getPublicSteps(category?: string): Promise<ProcedureStep[]> {
    const query = category ? `?category=${encodeURIComponent(category)}` : '';
    const res = await fetch(`${BASE_URL}/public${query}`);
    const data = await res.json();
    if (!data.success) throw new Error(data.message);
    return data.data;
  },
};
